import airbrake from 'common/airbrake';
import { getCurrentDomain } from 'common/currentDomain';
import { fetchJsonWithParsedError } from 'common/http';
import {
  fetchAllSubscriptionsForAsset,
  ScreenshotSubscription
} from 'common/notifications/api/ScreenshotSubscriptionsAPI';
import { CatalogInteractiveUser } from 'common/types/users/catalogUsers';
import { View } from 'common/types/view';
import InteractiveUser from 'common/types/users/interactiveUser';
import { ScheduleSendValues } from './types/scheduleSend';
import { buildPayload } from './builder';
import { showForgeSuccessToastNow } from '../ToastNotification/Toastmaster';
import { I18n } from 'common/visualizations';
import { createScheduleDelivery } from 'common/notifications/api/ScheduleDeliveryAPI';

const scope = 'shared.components.schedule_send_report.modal';

export const fetchExistingSubscriptions = async () => {
  try {
    return (await fetchAllSubscriptionsForAsset(window.STORY_DATA.uid).then((res) => res.data)) ?? [];
  } catch {
    return [] as ScreenshotSubscription[];
  }
};

export const fetchUsers = async (view: View) => {
  try {
    const params = [
      `domain=${view.domainCName || getCurrentDomain()}`,
      'include_teams=false',
      'only=site_members',
      'disabled=false',
      'future=false',
      'rights=can_collaborate'
    ].join('&');

    const url = `/api/catalog/v1/users?${params}`;
    const response: { results: CatalogInteractiveUser[] } = await fetchJsonWithParsedError(url);
    return response.results;
  } catch (error) {
    airbrake.notify({ error, context: { component: 'ScheduleSendReport: fetchUsers()' } });
    return [];
  }
};

export const postScheduleDeliveryRequest = async (
  scheduleSendValues: ScheduleSendValues,
  currentUser: InteractiveUser,
  setScheduledSendModalVisible: (value: React.SetStateAction<boolean>) => void
) => {
  try {
    const payload = buildPayload(scheduleSendValues, currentUser);
    let requestError: string = '';

    await createScheduleDelivery(payload).catch(async ({ response }) => {
      const body = await response.json();
      if (body.errors?.detail) {
        requestError = body.errors.detail;
      }
      // If we ever need error request id in the future, we can access it using:
      // response.headers.get('X-Socrata-RequestId');
    });

    if (requestError) {
      // Don't close modal on errors, we're just logging the error (for now)
      // showForgeErrorToastNow(errors.join(', '));
      console.error('Error creating schedule delivery:', requestError);
      return;
    } else {
      showForgeSuccessToastNow(I18n.t('success_toast', { scope }));
      setScheduledSendModalVisible(false);
    }
  } catch (error) {
    // Don't close modal on error, we're just logging the error
    console.error('Error creating screenshot subscription:', error);
  }
};
